module.exports = __webpack_public_path__ + "img/config-icon.5f49ce5d.svg";